import _L from "../../../util/Labels";
import { _ModalConfirmacion, IModalConfirmacionConfig } from "./ModalConfirmacion";
import { ModalThingsUtil as util } from "./Utils";

type TStrToModalBotons = util.TStrToModalBotons

export interface IModalConfirmacionBasicoV2Config extends Pick<IModalConfirmacionConfig, "Title" | "Width"> {
    /** Acepta string-html, si es `string` se appendiza dentro de un elemento `<label>` */
    Content: string | TSelectionHTML<"htmlelement"> | HTMLElement;
    /** @default "aceptar_cancelar" */
    TypeStrModalBotons?: TStrToModalBotons;
    /** @default true */
    Calcelable?: boolean;
}

/** // NOTE No tiene soporte para ajustar Lang context */
export function _ModalConfirmacionBasicoV2(config: IModalConfirmacionBasicoV2Config): Promise<boolean> {
    const { Content } = config;
    if (!config.Title) {
        config.Title = _L("general.msjconfirma");
    }
    return new Promise<boolean>(resolve => {
        const mt = _ModalConfirmacion({
            Title: config.Title,
            Message: typeof Content == "string" ? Content : null,
            DrawContent: (() => {
                if (typeof Content == "string") return null;
                else if (Content instanceof HTMLElement) return (container) => container.append(() => Content);
                else return (container) => container.append(() => Content.node());
            })(),
            Width: config.Width || 400,
            StrModalBotons: config.TypeStrModalBotons,
            OnAccept: () => resolve(true),
            OnClose: () => resolve(false),
        })
        if (config.Calcelable === false) {
            mt.Modal._EscKeydownEnabled = false;
            mt.BtnLeft.remove();
            mt.Modal._BtnCloseSelection.remove();
        }
    })
}